module.exports = __webpack_public_path__ + "static/media/05660030-5dU0wSgs.131f88c3.JPG";